import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

/**
 * Layout gate for every EventPay-internal ops page (/ops/pulse, /ops/revenue,
 * and whatever comes next). One superuser check here covers all children —
 * a new ops route cannot be added without inheriting it.
 *
 * This guard is UX (organizers get a redirect, not a 403); each ops endpoint
 * enforces the real boundary server-side.
 */
export const Route = createFileRoute('/_authenticated/ops')({
  beforeLoad: ({ context }) => {
    if (!context.auth.user?.is_superuser) {
      throw redirect({ to: '/events' })
    }
  },
  component: OpsLayout,
})

function OpsLayout() {
  return <Outlet />
}
